import { render } from "./AIAnalysisDetailModal.vue?vue&type=template&id=23845a29&scoped=true"
import script from "./AIAnalysisDetailModal.vue?vue&type=script&lang=js"
export * from "./AIAnalysisDetailModal.vue?vue&type=script&lang=js"

import "./AIAnalysisDetailModal.vue?vue&type=style&index=0&id=23845a29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23845a29"]])

export default __exports__